// extracted by mini-css-extract-plugin
export default {"customStatic":"CustomStatic_customStatic__kaqkg","indexInfo":"CustomStatic_indexInfo__3H+TO","indexName":"CustomStatic_indexName__MjvyI","indexVal":"CustomStatic_indexVal__DUY4J"};